import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './assets/theme.css'
import revela from './directives/revela'

loadFonts()

createApp(App)
  .directive('revela', revela)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
